import { BaseResourceModel } from "../../models/base-resource.model";
import { Fatura } from "./fatura.model";
import { LiquidacaoResto } from "./liquidacao-resto.model";

enum FaturaTipo {
  TAXA = 'T',
  JUROS = 'J',
  ATT_MONETARIA = 'A'
}

export class LiquidacaoRestoFaturaTipo extends BaseResourceModel {
  constructor(
    public liquidacao?: LiquidacaoResto,
    public fatura?: Fatura,
    public tipo?: FaturaTipo
  ) {
    super();
  }

  static converteJson(json: any): LiquidacaoRestoFaturaTipo {
    return Object.assign(new LiquidacaoRestoFaturaTipo(), json);
  }
}